import actionConsts from 'constants/actions';

const initialState = [];

const categories = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.INIT_GAME_DATA:
            return action.payload.categories;
        default:
            return state;
    }
};

export default categories;